export default "__VITE_ASSET__JEFcIp81__"